

import { FlexBox, Skeleton } from '@brg/ui';
import { FC, ReactNode, useLayoutEffect, useRef, useState } from 'react';
import { SceletonProps } from './slideNavigation';
import styled from 'styled-components';
import { useMemo } from 'react';
import { LayoutConst } from 'core';
import { useDebounceCallback } from 'shared/helpers/useDebounceCallback';

export interface SlideNavigationLayoutProps extends SceletonProps {
    isLoading?: boolean;
    content?: ReactNode;
    line?: ReactNode;
    autoWidth?: boolean;
    stretch?: boolean;
    autoFlex?: boolean;
    isDesigner?: boolean;
    fullWidth?: boolean;
    activeTabRef?: any;
    containerRef?: any;
    border?:string;
}

export const SlideNavigationLayoutMain = styled(FlexBox)`
    position: relative;
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        overflow-x: auto;
        overflow-y: visible;
        padding-bottom: 4px;
        box-sizing: border-box;

            ::-webkit-scrollbar {
                height: 2px;
                visibility: hidden;
                display: none;
            }
            ::-webkit-scrollbar-thumb {
                background: ${p => p.theme.competition.bg};
            }
            ::-webkit-scrollbar-track {
                background: #fff !important;
        }
        }
`

const ContentWrapper = styled(FlexBox)<{border?:string}>`
    min-height: 24;
    align-items: center; 
    overflow-x: visible;
    margin-bottom: 0;
    width: 100%;
    display: flex;
    position: static;
    border-bottom: ${({border})=> border && border};
`;

export const SlideNavigationLayout: FC<SlideNavigationLayoutProps> = (props) => {
    const { isLoading, content, autoWidth, stretch, fullWidth, autoFlex, sceletonOptions, isDesigner, activeTabRef, border } = props;

    const containerRef = useRef<any>(null)

    const [currentScroll, setCurrentScroll] = useState(0)
    const [tabOffsetLeft, setTabOffsetLeft] = useState(activeTabRef?.current?.offsetLeft || 0)

    const debouncedScroll = useDebounceCallback((v: any) => setCurrentScroll(v), 300)


    
    

    // useLayoutEffect(() => {
    //     if (activeTabRef?.current && containerRef?.current) {

    //         const { current: container } = containerRef
    //         const { current: tab } = activeTabRef

    //         const containerLeft = container.scrollLeft;
    //         const containerRight = currentScroll + container.clientWidth;

    //         const containerRect = container.getBoundingClientRect()
    //         const tabRect = tab.getBoundingClientRect()

    //         const tabLeft = tab.offsetLeft
    //         const tabRight = tab.offsetLeft + tab.offsetWidth

    //         console.log('scroll', currentScroll, containerRect, tabRect)

    //         // console.log('OFFSETS', {currentScroll, containerLeft, containerRight, tabLeft, tabOffsetLeft, tabRight})

    //         if (tabRect.left < containerRect.left - 1) {
    //             container.scrollLeft += tabRect.left + containerRect.left
    //             return
    //         }

    //         if (tabRect.right > containerRect.right + 1) {
    //             container.scrollLeft += tabRect.right - containerRect.right
    //             return
    //         }

    //         // if (tabRight > containerRight + 10 && tabLeft !== tabOffsetLeft) {
    //         //     console.log('rightScroll', {tabRight, containerRight, tabLeft, tabOffsetLeft})
    //         //     container.scrollLeft = tabRight - container.clientWidth
    //         //     setTabOffsetLeft(tabLeft)
    //         // }

    //         // if (tabLeft< container.scrollLeft) {
    //         //     console.log('left')
    //         //     container.scrollLeft = tabLeft; 
    //         // } else if (tabRight > container.scrollLeft + container.clientWidth) {
    //         //     console.log('right')
    //         //     container.scrollLeft = tabRight - container.clientWidth;
    //         // }

    //     }
    // }, [containerRef.current, activeTabRef.current])
    
    const defaultSceleton = useMemo(() => {
        if (sceletonOptions) {
            const arr: any = []
            arr.length = sceletonOptions.col
            return (
                <FlexBox gx={sceletonOptions.gx} align="center" style={{ placeItems: 'center' }}>
                    {
                        arr.fill(1).map((i: any) => {
                            return (
                                <Skeleton width={sceletonOptions.w} height={sceletonOptions.h} />
                            )
                        })
                    }         
                </FlexBox>
            )
        }
        else {
            return (
                <FlexBox gx={1}>
                    <Skeleton width={120} height={20} />
                    <Skeleton width={120} height={20} />
                    <Skeleton width={120} height={20} />
                    <Skeleton width={120} height={20} />
                </FlexBox>
            )
        }
    }, [sceletonOptions]);
    return (
        <SlideNavigationLayoutMain
            direction={'column'}
            width={autoWidth ? 'auto' : '100%'}
            flex={autoFlex ? '1' : undefined}
            className={'snl slide-navigation-layout'}
            ref={containerRef}
            // onScroll={(e:any) => debouncedScroll(e.target.scrollLeft)}
        >
            <ContentWrapper 
                width={'100%'}
                border={border}>
                {isLoading ? (
                    defaultSceleton
                ) : (
                    content
                )}
            </ContentWrapper>
        </SlideNavigationLayoutMain>
    );
};


import { FlexBox, Skeleton } from '@brg/ui';
import { FC, ReactNode, useLayoutEffect, useRef, useState } from 'react';
import { SceletonProps } from './slideNavigation';
import styled from 'styled-components';
import { useMemo } from 'react';
import { LayoutConst } from 'core';
import { useDebounceCallback } from 'shared/helpers/useDebounceCallback';

export interface SlideNavigationLayoutProps extends SceletonProps {
    isLoading?: boolean;
    content?: ReactNode;
    line?: ReactNode;
    autoWidth?: boolean;
    stretch?: boolean;
    autoFlex?: boolean;
    isDesigner?: boolean;
    fullWidth?: boolean;
    activeTabRef?: any;
    containerRef?: any;
    border?:string;
}

export const SlideNavigationLayoutMain = styled(FlexBox)`
    position: relative;
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        overflow-x: auto;
        overflow-y: visible;
        padding-bottom: 4px;
        box-sizing: border-box;

            ::-webkit-scrollbar {
                height: 2px;
                visibility: hidden;
                display: none;
            }
            ::-webkit-scrollbar-thumb {
                background: ${p => p.theme.competition.bg};
            }
            ::-webkit-scrollbar-track {
                background: #fff !important;
        }
        }
`

const ContentWrapper = styled(FlexBox)<{border?:string}>`
    min-height: 24;
    align-items: center; 
    overflow-x: visible;
    margin-bottom: 0;
    width: 100%;
    display: flex;
    position: static;
    border-bottom: ${({border})=> border && border};
`;

export const SlideNavigationLayout: FC<SlideNavigationLayoutProps> = (props) => {
    const { isLoading, content, autoWidth, stretch, fullWidth, autoFlex, sceletonOptions, isDesigner, activeTabRef, border } = props;

    const containerRef = useRef<any>(null)

    const [currentScroll, setCurrentScroll] = useState(0)
    const [tabOffsetLeft, setTabOffsetLeft] = useState(activeTabRef?.current?.offsetLeft || 0)

    const debouncedScroll = useDebounceCallback((v: any) => setCurrentScroll(v), 300)


    
    

    // useLayoutEffect(() => {
    //     if (activeTabRef?.current && containerRef?.current) {

    //         const { current: container } = containerRef
    //         const { current: tab } = activeTabRef

    //         const containerLeft = container.scrollLeft;
    //         const containerRight = currentScroll + container.clientWidth;

    //         const containerRect = container.getBoundingClientRect()
    //         const tabRect = tab.getBoundingClientRect()

    //         const tabLeft = tab.offsetLeft
    //         const tabRight = tab.offsetLeft + tab.offsetWidth

    //         console.log('scroll', currentScroll, containerRect, tabRect)

    //         // console.log('OFFSETS', {currentScroll, containerLeft, containerRight, tabLeft, tabOffsetLeft, tabRight})

    //         if (tabRect.left < containerRect.left - 1) {
    //             container.scrollLeft += tabRect.left + containerRect.left
    //             return
    //         }

    //         if (tabRect.right > containerRect.right + 1) {
    //             container.scrollLeft += tabRect.right - containerRect.right
    //             return
    //         }

    //         // if (tabRight > containerRight + 10 && tabLeft !== tabOffsetLeft) {
    //         //     console.log('rightScroll', {tabRight, containerRight, tabLeft, tabOffsetLeft})
    //         //     container.scrollLeft = tabRight - container.clientWidth
    //         //     setTabOffsetLeft(tabLeft)
    //         // }

    //         // if (tabLeft< container.scrollLeft) {
    //         //     console.log('left')
    //         //     container.scrollLeft = tabLeft; 
    //         // } else if (tabRight > container.scrollLeft + container.clientWidth) {
    //         //     console.log('right')
    //         //     container.scrollLeft = tabRight - container.clientWidth;
    //         // }

    //     }
    // }, [containerRef.current, activeTabRef.current])
    
    const defaultSceleton = useMemo(() => {
        if (sceletonOptions) {
            const arr: any = []
            arr.length = sceletonOptions.col
            return (
                <FlexBox gx={sceletonOptions.gx} align="center" style={{ placeItems: 'center' }}>
                    {
                        arr.fill(1).map((i: any) => {
                            return (
                                <Skeleton width={sceletonOptions.w} height={sceletonOptions.h} />
                            )
                        })
                    }         
                </FlexBox>
            )
        }
        else {
            return (
                <FlexBox gx={1}>
                    <Skeleton width={120} height={20} />
                    <Skeleton width={120} height={20} />
                    <Skeleton width={120} height={20} />
                    <Skeleton width={120} height={20} />
                </FlexBox>
            )
        }
    }, [sceletonOptions]);
    return (
        <SlideNavigationLayoutMain
            direction={'column'}
            width={autoWidth ? 'auto' : '100%'}
            flex={autoFlex ? '1' : undefined}
            className={'snl slide-navigation-layout'}
            ref={containerRef}
            // onScroll={(e:any) => debouncedScroll(e.target.scrollLeft)}
        >
            <ContentWrapper 
                width={'100%'}
                border={border}>
                {isLoading ? (
                    defaultSceleton
                ) : (
                    content
                )}
            </ContentWrapper>
        </SlideNavigationLayoutMain>
    );
};
